/**
 * Navigation Components
 */

import { Sun, Moon, ArrowRight, Menu, X } from 'lucide-react';
import { useState } from 'react';

const NavLink = ({ to, children, currentPath, onNavigate, isLight, isMobile }) => {
  const isActive = currentPath === to;
  return (
    <button
      onClick={() => onNavigate(to)}
      className={`uppercase tracking-[0.25em] transition-all relative group whitespace-nowrap text-left ${
        isMobile 
          ? `text-xl py-4 flex items-center justify-between w-full ${isActive ? 'font-black opacity-100' : 'opacity-40'}`
          : `text-[10px] px-2 py-1 ${isActive ? 'opacity-100 font-black' : 'opacity-40 hover:opacity-100'}`
      } ${isLight ? 'text-slate-900' : 'text-white'}`}
    >
      <span>{children}</span>
      {isMobile && isActive && <ArrowRight size={20} className="text-cyan-500" />}
    </button>
  );
};

export const Navbar = ({ currentPath, onNavigate, isLight, onToggleTheme, user }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleNavigate = (path) => {
    onNavigate(path);
    setIsOpen(false);
  };
  console.log(user);
  const navLinks = [
    { to: '/scanner', label: 'Scanner' },
    { to: '/pricing', label: 'Pricing' },
    { to: '/about', label: 'About' },
    { to: '/feedback', label: 'Feedback' },
    { to: user ? '/profile' : '/login', 
      label: user 
                ? (user.displayName 
                    ? (user.displayName.length > 7 
                        ? user.displayName.substring(0, 7) + "..." 
                        : user.displayName)
                    : 'Account') 
                : 'Login' 
    },
  ];

  return (
    <nav className="mt-6 md:mt-8 mb-12 md:mb-16 w-full relative">
      <div className="flex flex-row items-center justify-between px-2">
        {/* Mobile Menu Button */}
        <button 
          onClick={() => setIsOpen(true)}
          className={`md:hidden p-2 rounded-lg transition-all active:scale-95 ${
            isLight ? 'bg-slate-100 text-slate-900' : 'bg-white/5 text-white'
          }`}
        >
          <Menu size={20} />
        </button>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-6 flex-grow">
          {navLinks.map((link) => (
            <NavLink 
              key={link.to} 
              to={link.to} 
              currentPath={currentPath} 
              onNavigate={handleNavigate} 
              isLight={isLight}
            >
              {link.label}
            </NavLink>
          ))}
        </div>
        
        {/* Theme Toggle */}
        <button 
          onClick={onToggleTheme}
          className={`p-2.5 rounded-3xl transition-all duration-500 hover:scale-110 active:scale-95 shadow-lg flex-shrink-0 ${
            isLight ? 'bg-slate-200 text-slate-800 shadow-slate-200/50' : 'bg-white/10 text-white hover:bg-white/20 shadow-black/50'
          }`}
        >
          {isLight ? <Moon size={14} /> : <Sun size={14} />}
        </button>
      </div>

      {/* Mobile Floating Menu Overlay */}
      {isOpen && (
        <div className="fixed inset-0 z-[100] md:hidden animate-in">
          {/* Blur Backdrop */}
          <div 
            className="absolute inset-0 bg-black/60 backdrop-blur-xl"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Menu Panel */}
          <div className={`absolute right-0 top-0 bottom-0 w-4/5 max-w-sm shadow-2xl p-8 flex flex-col transition-transform duration-500 ${
            isLight ? 'bg-white text-slate-900' : 'bg-[#0d0d0f] text-white border-l border-white/10'
          }`}>
            <div className="flex justify-between items-center mb-12">
              <span className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40">Navigation</span>
              <button 
                onClick={() => setIsOpen(false)}
                className={`p-2 rounded-3xl ${isLight ? 'bg-slate-100' : 'bg-white/5'}`}
              >
                <X size={20} />
              </button>
            </div>

            <div className="flex flex-col gap-2 flex-grow">
              {navLinks.map((link) => (
                <NavLink 
                  key={link.to} 
                  to={link.to} 
                  currentPath={currentPath} 
                  onNavigate={handleNavigate} 
                  isLight={isLight}
                  isMobile={true}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>

            <div className="pt-8 border-t border-white/5 mt-auto">
               <div className="text-[8px] font-mono tracking-widest opacity-30 uppercase">
                 Auth Session: Active
               </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

